// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"_3_01fOopnX44ubS-oaxkTR","OrderButton":"myBwTggVYuoTSZ0phsfQj","enable":"_3jYIqaQjQmo_d3HEVAUYmZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 124
// module chunks = 0